





















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ShiftStore} from "./store";
import ShiftForm from "@/modules/shift/components/Form/index.vue";
import {ShiftParams} from "@/modules/shift/params";
import {ShiftType} from "@/modules/shift/type/shifttype";
import {RoleDeclare} from "@/enums/roledeclare";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 20
    },
    {
        title: 'Thao tác',
        dataIndex: 'id',
        key: 'action',
        scopedSlots: { customRender: "action" },
        width: 50
    },
    {
        title: 'Thời gian bắt đầu',
        dataIndex: 'start',
        key: 'start',
        width: 100
    },
    {
        title: 'Thời gian kết thúc',
        dataIndex: 'end',
        key: 'end',
        width: 100
    },
    {
        title: 'Loại ca',
        dataIndex: 'type',
        key: 'type',
        scopedSlots: { customRender: "type" },
        width: 100
    }
]
@Component({
    name: "ShiftList",
    components: {ShiftForm}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    visibleForm = false;
    ShiftType = ShiftType;
    titleForm = "Tạo ca";
    shiftId = null;

    created() {
        ShiftStore.updateParamsShift(new ShiftParams());
        ShiftStore.listShift(ShiftStore.params);
    }

    get shifts() {
        return ShiftStore.ids.map((id: number) => ShiftStore.data[id]);
    }

    get pagination() {
        return {
            current: ShiftStore.meta.page,
            pageSize: ShiftStore.meta.limit,
            total: ShiftStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} ca`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onchangePage(pagination: any) {
        ShiftStore.updateParamsShift({
            ...ShiftStore.params,
            page: pagination.current
        });
        ShiftStore.listShift(ShiftStore.params);
    }

    async onConfirm(id: number) {
        if (!this.hasPermissionCRUDShift(RoleDeclare.ROLE_CAN_DELETE_SHIFT)) return;
        try {
            await ShiftStore.deleteShift(id);
            this.$message.success("Xóa ca thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa ca thất bại');
        }
    }

    async showFormEdit(id: number) {
        if (!this.hasPermissionCRUDShift(RoleDeclare.ROLE_CAN_EDIT_SHIFT)) return;
        try {
            await ShiftStore.singleShift(id);
            this.shiftId = id as any;
            this.visibleForm = true;
        } catch (e) {
        }
    }

    showFormCreate() {
        if (!this.hasPermissionCRUDShift(RoleDeclare.ROLE_CAN_CREATE_SHIFT)) return;
        this.shiftId = null;
        this.visibleForm = true;
    }
    hasPermissionCRUDShift(role: string) {
        if (!this.hasPermission(role)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return false;
        }
        return true
    }
}
